import { Flex, Card as AntCard, theme } from 'antd';

import type { ReactNode } from 'react';
import type React from 'react';

type CardProps = Omit<React.ComponentProps<typeof AntCard>, 'actions'> & {
  bgIcon?: ReactNode;
  title?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  className?: string;
  id?: string;
};

const Card = ({
  bgIcon,
  title,
  meta,
  actions,
  className,
  id,
  hoverable,
  children,
  ...props
}: CardProps) => {
  const { token } = theme.useToken();

  return (
    <AntCard
      id={id}
      hoverable={hoverable}
      title={title}
      className={className}
      styles={
        bgIcon
          ? {
              body: { position: 'relative', overflow: 'hidden' },
            }
          : undefined
      }
      extra={
        meta || actions ? (
          <Flex align="center" gap="small">
            {meta}
            {actions}
          </Flex>
        ) : undefined
      }
      {...props}
    >
      {bgIcon ? (
        <div
          aria-hidden
          style={{
            position: 'absolute',
            right: -12,
            bottom: -12,
            width: 'clamp(64px, 8vw, 96px)',
            opacity: 0.08,
            pointerEvents: 'none',
            color: token.colorTextTertiary,
            fontSize: 'clamp(64px, 8vw, 96px)',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {bgIcon}
        </div>
      ) : null}
      {children}
    </AntCard>
  );
};

export default Card;
